<template>
  <div>
    <div class="text-nowrap">
      <b-dropdown
        size="sm"
        :text="data.status"
        :variant="badgeVariant(data.status)"
        class="text-light"
      >
        <b-dropdown-item
          v-if="showOption('pending')"
          style="z-index: 999"
          @click="handleStatusClick('pending', data.id)"
        >
          Pending
        </b-dropdown-item>
        <b-dropdown-item
          v-if="showOption('approved')"
          style="z-index: 999"
          @click="handleStatusClick('approved', data.id)"
        >
          Approved
        </b-dropdown-item>
        <b-dropdown-item
          v-if="showOption('printed')"
          style="z-index: 999"
          @click="handleStatusClick('printed', data.id)"
        >
          Printed
        </b-dropdown-item>
        <b-dropdown-item
          v-if="showOption('rejected') && $store.state.app.permissions.includes('show-rejected')"
          style="z-index: 999"
          @click="handleStatusClick('rejected', data.id)"
        >
          Rejected
        </b-dropdown-item>
      </b-dropdown>

      <ChangeInvoiceStatus
        :key="InvoiceId"
        :name="name"
        :endpoint="endpoint"
        :inovice-id="InvoiceId"
        :invoicestatus="invoiceLatestStatus"
        @onChange="$emit('onEmit')"
      />
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import ChangeInvoiceStatus from '@/components/modals/ChangeInvoiceStatus.vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    ChangeInvoiceStatus,
  },
  props: ['data', 'endpoint', 'name'],
  data() {
    return {
      invoiceLatestStatus: '',
      InvoiceId: '',
    }
  },
  methods: {
    handleStatusClick(status, id) {
      // Store invoice ID in localStorage if changing to approved
      if (status === 'approved' && this.data.status !== 'approved') {
        localStorage.setItem(
          'pendingAutoPrintInvoice',
          JSON.stringify({ invoiceId: id, timestamp: Date.now() }),
        )
      }
      // Emit event for parent component
      this.$emit('onStatusChange', status, id)
      // Show the modal
      this.showChangeStatusModal(status, id)
    },
    showChangeStatusModal(status, id) {
      this.invoiceLatestStatus = status
      this.InvoiceId = id
      this.$nextTick(() => {
        this.$bvModal.show(`modal-confirm-edit-${id}`)
      })
    },
    badgeVariant(status) {
      switch (status) {
        case 'pending':
          return 'warning'
        case 'rejected':
          return 'danger'
        case 'printed':
          return 'info'
        default:
          return 'success'
      }
    },
    showOption(option) {
      const statusSequence = ['pending', 'approved', 'printed']
      const currentIndex = statusSequence.indexOf(this.data.status)
      const optionIndex = statusSequence.indexOf(option)

      if (this.data.status === 'printed' || this.data.status === 'rejected') {
        return false
      }

      return option === 'rejected' || optionIndex === currentIndex + 1
    },
  },
}
</script>
